import { useCallback, useState } from 'react'

export default function useForm({
  defaultValues,
  requiredValidations,
}: {
  defaultValues: { [key: string]: any }
  requiredValidations: { [key: string]: (value: any) => boolean }
}): {
  getFieldChangeHandler: (string) => (any) => void
  getRequiredValidationMetByField: (field) => boolean
  isValid: boolean
  values: { [key: string]: any }
} {
  const [values, setValues] = useState(defaultValues)

  const getFieldChangeHandler = useCallback(
    (field: string): ((newValue: any) => void) =>
      (newValue: any): void => {
        setValues((previousValues) => ({
          ...previousValues,
          [field]: newValue,
        }))
      },
    [setValues],
  )

  const isValid = Object.entries(requiredValidations)
    .map(([field, validationFn]) => validationFn(values[field]))
    .every((result) => result === true)

  return {
    getFieldChangeHandler,
    getRequiredValidationMetByField: (field) =>
      requiredValidations[field](values[field]),
    isValid,
    values,
  }
}
